import { Routes, Route } from "react-router-dom";
import Dashboard from "./pages/dashboard";
import Settings from "./pages/settings";
//import CalendarPage from "./pages/calendar";
import { CustomProvider } from "rsuite";
import enGB from "rsuite/locales/en_GB";
import { appNavs } from "./config";
import Frame from "./components/CustomizedFrame";
//import Settings from "./pages/Settings";

export default function AppRoutes() {
  return (
    <CustomProvider locale={enGB}>
      <Routes>
        <Route path="/" element={<Frame navs={appNavs} />}>
          <Route index element={<Dashboard />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/settings" element={<Settings />} />
        </Route>
        {/*<Route path="/calendar" element={<CalendarPage />} /><Route path="/settings" element={<Settings />} />*/}
      </Routes>
    </CustomProvider>
  );
}
